import { useQuery } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { getMappedApprovedParametersData } from "mappers";
import { creditReviewDetailsService } from "services";
import { uiActions } from "store";
import { ExecutiveApprovedParametersDto, ErrorResponse } from "types";

type useGetApprovedParametersQueryProps = {
	creditReviewId: string;
};

const useGetApprovedParametersQuery = ({
	creditReviewId,
}: useGetApprovedParametersQueryProps) => {
	const dispatch = useDispatch();

	const queryResult = useQuery(
		["executiveApprovedParametersInfo", creditReviewId],
		() =>
			creditReviewDetailsService.getApprovedParametersInfo({
				creditReviewId,
			}),
		{
			select: (data: ExecutiveApprovedParametersDto) => {
				return getMappedApprovedParametersData(data);
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
			enabled: !!creditReviewId,
			cacheTime: 0,
		},
	);

	return queryResult;
};

export default useGetApprovedParametersQuery;
